import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LogService } from '../services/log.service';
import { RootScopeService } from '../services/root-scope.service';
import { AlertMsg, ERROR, INFO, SUCCESS, WARNING, } from '../models/Constants';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private log: LogService, private rootScope: RootScopeService) { }
 /* istanbul ignore next */
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let isShowMsg: string = "";
    if (request.params.has('isShowMsg') && request.params.get("isShowMsg") != "false") {
      isShowMsg = AlertMsg.ApiCall;//request.params.get("isShowMsg") || 
      // this.rootScope.enableAlerts(SUCCESS, isShowMsg);
    }

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse && !event?.url?.includes('awcp/user/isSessionActive') && !event?.url?.includes('localhost') && !event?.url?.includes('fetchPrivacyPolicyStatus')) {
        this.rootScope.hideError();
        //if (event.body.message && event.body.message != "No results found."&&event.body.message!="Success") this.rootScope.enableAlerts(WARNING, event.body.message);
      }
    }),
      catchError((err) => {
        this.rootScope.hideError();
        const errorMessage = this.setError(err);
        // if (!err.url.includes("awcp/api/link")) 
        //   // this.rootScope.enableAlerts(ERROR, errorMessage ? errorMessage : AlertMsg.serverError);

        return throwError(errorMessage);
      })
    );
  }
 /* istanbul ignore next */
  setError(error: HttpErrorResponse): any {
    let errorMessage: string = AlertMsg.serverError;
    if (error.error instanceof ErrorEvent) {
      // client side error
      errorMessage = error.error.message;
      this.log.error(errorMessage)
    } else {
      // server side error
      if (error.status != 0) {
        errorMessage = error.error.message;
        this.log.error(errorMessage, true);
      }
    }
    return error;
  }


}
